var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24268 8.42424H25.6972L22.7881 18.1212H8.24268",
    stroke: "#257FFC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18201 25.8788C9.18201 26.3976 8.76143 26.8182 8.24262 26.8182C7.7238 26.8182 7.30322 26.3976 7.30322 25.8788C7.30322 25.36 7.7238 24.9394 8.24262 24.9394C8.76143 24.9394 9.18201 25.36 9.18201 25.8788Z",
    fill: "#020025",
    stroke: "#257FFC",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6971 25.8788C24.6971 26.3976 24.2766 26.8182 23.7578 26.8182C23.2389 26.8182 22.8184 26.3976 22.8184 25.8788C22.8184 25.36 23.2389 24.9394 23.7578 24.9394C24.2766 24.9394 24.6971 25.36 24.6971 25.8788Z",
    fill: "#020025",
    stroke: "#257FFC",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 5.51515L8.24259 8.42424V18.1212L6.30319 22H26.6668",
    stroke: "#257FFC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.5f33fbe4.svg";
export { ForwardRef as ReactComponent };